// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import BreadcrumbNav from '../../../view/nav/BreadcrumbNav';
import LoadingState from '../../../view/common/LoadingState';
import NotificationSettingsList from './NotificationSettingsList';

import loadNotificationSettings from '../state/loadNotificationSettings';
import Console from '../../../lib/debug';

type Props = {
    dispatch: () => any,
    appLoading: boolean,
    settingsList: Array<any>
};

const crumbs = [
    {
        displayString: 'Notification Settings',
        link: `/notification-settings`,
        editable: false
    }
];

export class NotificationSettingsClass extends PureComponent<Props> {
    constructor(props: any) {
        super(props);
        this.props.dispatch(loadNotificationSettings());
    }

    getLoadingState() {
        if (!this.props.appLoading) {
            return null;
        }

        return <LoadingState />;
    }

    getSettings() {
        const { appLoading, settingsList } = this.props;

        if (appLoading || settingsList.length < 1) {
            return null;
        }

        return (
            <div>
                <div className="jumbotron">
                    <h1>Notification Settings</h1>
                </div>
                <NotificationSettingsList settingsList={settingsList} />
            </div>
        );
    }

    render() {
        Console.render('Notification Settings');
        const notificationSettings = this.getSettings();
        const loadingState = this.getLoadingState();

        return (
            <div className="notification-settings">
                <BreadcrumbNav crumbs={crumbs} />
                {notificationSettings}
                {loadingState}
            </div>
        );
    }
}

const mapStateToProps = (state: {}, ownProps: any) => {
    return {
        ...ownProps,
        appLoading: state.app.appLoading,
        settingsList: state.notificationSettings.notificationSettingsList
    };
};

export default connect(mapStateToProps)(NotificationSettingsClass);
